import { Component, OnInit } from '@angular/core';
import { Menu, NavService } from '../../../../services/nav.service';
import { GlobalVariable } from '../../../../helpers/settings';
import { UserService } from '../../../../services/user.service';
import { RoleService } from '../../../../services/user-role.service';
import { Role } from '../../../../models/user-role';

@Component({
	selector: 'app-header-settings',
	templateUrl: './header-settings.component.html',
	styleUrls: ['./header-settings.component.scss']
})
export class HeaderSettingsComponent implements OnInit {
	public menuItems: Menu[] = [];
	public items: Menu[] = [];
	public configModules: any[] = [
		{
			path: 'admin/' + GlobalVariable['PROJECT'].route,
			route: GlobalVariable['PROJECT'].route,
			svgIcon: GlobalVariable['PROJECT'].svgIcon,
			title: 'Projects'
		},
		{
			path: 'admin/' + GlobalVariable['USER'].route,
			route: GlobalVariable['USER'].route,
			svgIcon: GlobalVariable['USER'].svgIcon,
			title: 'Users'
		},
		{
			path: 'admin/' + GlobalVariable['CUSTOM_TYPES'].route,
			route: GlobalVariable['CUSTOM_TYPES'].route,
			svgImage: GlobalVariable['CUSTOM_TYPES'].svgImage,
			title: 'Custom Inputs'
		}
	];
	public text: string = '';

	public bookmarkFlip = false;
	public bookmark = false;

	public open = false;
	public searchResult = false;
	public searchResultEmpty = false;
	public hasAccessToModules = [];

	constructor(private userService: UserService, private roleService: RoleService) {}

	ngOnInit(): void {
		this.hasAccessToModules = this.configModules.map(m => this.veryfyAccess(m.route));
	}

	veryfyAccess(componentRoute) {
		const user = this.userService.getCurrentUser();
		if (this.roleService.hasOwnerAccess()) return true;
		if (user?.roles?.includes('User')) {
			const currentUserRole: Role = user?.userRole?.role as Role;
			return this.roleService.getAuthorizationConfigComponent(currentUserRole, componentRoute, null);
		}
	}

	ToggleSearch() {
		this.open = !this.open;
		this.removeFix();
	}

	openBookMark() {
		this.bookmark = !this.bookmark;
	}

	flipBookMark() {
		this.bookmarkFlip = !this.bookmarkFlip;
	}

	searchTerm(term: any) {
		term ? this.addFix() : this.removeFix();
		if (!term) {
			this.open = false;
			return (this.menuItems = []);
		}
		const items: any = [];
		term = term.toLowerCase();
		this.items.filter((menuItems: any) => {
			if (!menuItems?.title) return false;
			if (menuItems.title.toLowerCase().includes(term) && menuItems.type === 'link') {
				items.push(menuItems);
			}
			if (!menuItems.children) {
				return false;
			}
			menuItems.children.filter((subItems: any) => {
				if (subItems.title.toLowerCase().includes(term) && subItems.type === 'link') {
					subItems.icon = menuItems.icon;
					items.push(subItems);
				}
				if (!subItems.children) {
					return false;
				}
				subItems.children.filter((suSubItems: any) => {
					if (suSubItems.title.toLowerCase().includes(term)) {
						suSubItems.icon = menuItems.icon;
						items.push(suSubItems);
					}
				});
				return;
			});
			this.checkSearchResultEmpty(items);

			return (this.menuItems = items);
		});
		return;
	}
	checkSearchResultEmpty(items: string) {
		if (!items.length) {
			this.searchResultEmpty = true;
		} else {
			this.searchResultEmpty = false;
		}
	}

	addFix() {
		this.searchResult = true;
	}

	removeFix() {
		this.searchResult = false;
		this.text = '';
	}
}
